/**
 * Converte texto de quantidade opcional: vazio/whitespace -> undefined; "0" -> 0.
 * @param {string|number|null|undefined} value
 * @returns {number|undefined}
 */
export const parseQuantidadeOpcional = (value) => {
  if (value === null || value === undefined) {
    return undefined;
  }

  const trimmed = String(value).trim();
  if (trimmed.length === 0) {
    return undefined;
  }

  const parsed = parseInt(trimmed, 10);
  if (Number.isNaN(parsed)) {
    return undefined;
  }

  return parsed;
};
